import React from 'react';
import { signinRedirect } from '../../services/userService';
import { useHistory } from 'react-router-dom';
import Config from '../../config';

function Login() {
  const history = useHistory();

  if (Config.isProd) {
    signinRedirect();
  } else {
    history.push('/');
  }

  return <h2>Redirecting...</h2>;
}

export default Login;
